import { Dimensions } from "react-native-web";
import { tokens } from "@opendoor/tokens-studio/dist/bricks-next/tokens/Components";
import { getTokenValue } from "@tamagui/core";
import { Toast as TamaguiToast } from "@tamagui/toast";
import { getOpacityTokenValue } from "../../helpers/tokens";
import { Box } from "../Box";
import { CloseButton } from "../Button";
import { Text } from "../Text";
import { jsx, jsxs } from "react/jsx-runtime";
const { toast: toastTokens } = tokens, Toast = ({
  message,
  duration = 3e3,
  analyticsName,
  trackImpression,
  onOpenChange,
  isOpen,
  isSuccess = !1,
  hasError = !1,
  onClose
}) => {
  const { width: screenWidth } = Dimensions.get("window"), width = screenWidth * 0.95;
  function handleToastOpenChange(open) {
    open || onClose?.(), onOpenChange?.(open);
  }
  const getBackgroundColor = () => hasError ? toastTokens.color.background.error : isSuccess ? toastTokens.color.background.success : toastTokens.color.background.default;
  return /* @__PURE__ */ jsx(
    TamaguiToast,
    {
      zIndex: 1e3,
      open: isOpen,
      onOpenChange: handleToastOpenChange,
      animation: toastTokens.animation.timing.default,
      enterStyle: {
        x: 0,
        y: toastTokens.animation.enterTransition.offset.start,
        opacity: getOpacityTokenValue(toastTokens.animation.opacity.enter.start)
      },
      exitStyle: {
        x: 0,
        y: -getTokenValue(toastTokens.animation.exitTransition.end),
        opacity: getOpacityTokenValue(toastTokens.animation.opacity.exit.end)
      },
      duration,
      $largerThanSM: {
        borderRadius: toastTokens.radius.size.m,
        marginVertical: toastTokens.margin.topBottom.m,
        paddingVertical: toastTokens.padding.topBottom.m,
        paddingHorizontal: toastTokens.padding.leftRight.m
      },
      $largerThanMD: {
        borderRadius: toastTokens.radius.size.lAndXl,
        marginVertical: toastTokens.margin.topBottom.lAndXl,
        paddingVertical: toastTokens.padding.topBottom.lAndXl,
        paddingHorizontal: toastTokens.padding.leftRight.lAndXl
      },
      marginVertical: toastTokens.margin.topBottom.xsAndS,
      paddingVertical: toastTokens.padding.topBottom.xsAndS,
      paddingHorizontal: toastTokens.padding.leftRight.xsAndX,
      borderRadius: toastTokens.radius.size.sAndXs,
      backgroundColor: getBackgroundColor(),
      width,
      maxWidth: toastTokens.size.maxWidth,
      children: /* @__PURE__ */ jsxs(
        Box,
        {
          justifyContent: "space-between",
          analyticsName: `${analyticsName}-toast`,
          trackImpression,
          flexDirection: "row",
          alignItems: "center",
          children: [
            /* @__PURE__ */ jsx(
              Text,
              {
                tag: "span",
                color: toastTokens.color.content.valueText.default,
                typography: toastTokens.typography.valueText,
                children: message
              }
            ),
            /* @__PURE__ */ jsx(TamaguiToast.Close, { asChild: !0, children: /* @__PURE__ */ jsx(CloseButton, { analyticsName: `${analyticsName}-close`, size: "small", variant: "inverse" }) })
          ]
        }
      )
    }
  );
};
export {
  Toast
};
